// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".with-legal{padding-bottom:0!important}.card-legal-copy{font-size:75%!important}", ""]);
// Exports
module.exports = exports;
